import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { authLogin, authLogout, authMe } from "../lib/api";

const AuthContext = createContext(null);

/**
 * States:
 *   user === undefined → still checking session
 *   user === null      → not logged in
 *   user === {...}     → admin logged in
 */
export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);

  const refresh = useCallback(async () => {
    try {
      const me = await authMe();
      setUser(me);
      return me;
    } catch {
      setUser(null);
      return null;
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const data = await authLogin(email, password);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await authLogout();
    } finally {
      setUser(null);
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
